const ID = ':id';

export const ADMIN_P = 'admin';
export const ADMIN_PF = `/${ADMIN_P}`;

export const LCADMIN_P = 'logchain-admin';
export const LCADMIN_PF = `${ADMIN_PF}/${LCADMIN_P}`;

export const COMPANIES_P = 'companies';
export const COMPANIES_PF = `${ADMIN_PF}/${COMPANIES_P}`;
export const LC_COMPANIES_PF = `${LCADMIN_PF}/${COMPANIES_P}`;

export const ADMIN_REGULATORY_P = 'regulatory';
export const ADMIN_REGULATORY_PF = `${ADMIN_PF}/${ADMIN_REGULATORY_P}`;
export const LCADMIN_REGULATORY_PF = `${LCADMIN_PF}/${ADMIN_REGULATORY_P}`;
export const ADMIN_REGULATORY_ID_P = `${ADMIN_REGULATORY_P}/${ID}`;
export const ADMIN_REGULATORY_ID_PF = `${ADMIN_PF}/${ADMIN_REGULATORY_ID_P}`;
export const LCADMIN_REGULATORY_ID_PF = `${LCADMIN_PF}/${ADMIN_REGULATORY_ID_P}`;

export const ADMIN_TRANSACTIONS_P = 'transactions';
export const ADMIN_TRANSACTIONS_PF = `${ADMIN_PF}/${ADMIN_TRANSACTIONS_P}`;
export const LCADMIN_TRANSACTIONS_PF = `${LCADMIN_PF}/${ADMIN_TRANSACTIONS_P}`;
export const ADMIN_TRANSACTIONS_DB_P = `dashboard`;
export const ADMIN_TRANSACTIONS_DB_PF = `${ADMIN_TRANSACTIONS_PF}/${ADMIN_TRANSACTIONS_DB_P}`;
export const LCADMIN_TRANSACTIONS_DB_PF = `${LCADMIN_TRANSACTIONS_PF}/${ADMIN_TRANSACTIONS_DB_P}`;
export const ADMIN_TRANSACTIONS_LIST_P = `list`;
export const ADMIN_TRANSACTIONS_LIST_PF = `${ADMIN_TRANSACTIONS_PF}/${ADMIN_TRANSACTIONS_LIST_P}`;
export const LCADMIN_TRANSACTIONS_LIST_PF = `${LCADMIN_TRANSACTIONS_PF}/${ADMIN_TRANSACTIONS_LIST_P}`;
export const ADMIN_TRANSACTIONS_ID_P = `detail/${ID}`;
export const ADMIN_TRANSACTIONS_ID_PF = `${ADMIN_TRANSACTIONS_PF}/${ADMIN_TRANSACTIONS_ID_P}`;
export const LCADMIN_TRANSACTIONS_ID_PF = `${LCADMIN_TRANSACTIONS_PF}/${ADMIN_TRANSACTIONS_ID_P}`;

export const ADMIN_COMPANY_P = 'company';
export const ADMIN_COMPANY_PF = `${ADMIN_PF}/${ADMIN_COMPANY_P}`;
export const LCADMIN_COMPANY_PF = `${LCADMIN_PF}/${ADMIN_COMPANY_P}`;
export const ADMIN_COMPANY_EDIT_PERSONA_P = `${ADMIN_COMPANY_P}/edit-persona`;
export const ADMIN_COMPANY_EDIT_PERSONA_PF = `${ADMIN_PF}/${ADMIN_COMPANY_EDIT_PERSONA_P}`;
export const LCADMIN_COMPANY_EDIT_PERSONA_PF = `${LCADMIN_PF}/${ADMIN_COMPANY_EDIT_PERSONA_P}`;
export const ADMIN_COMPANY_EDIT_INFO_P = `${ADMIN_COMPANY_P}/edit-info`;
export const ADMIN_COMPANY_EDIT_INFO_PF = `${ADMIN_PF}/${ADMIN_COMPANY_EDIT_INFO_P}`;
export const LCADMIN_COMPANY_EDIT_INFO_PF = `${LCADMIN_PF}/${ADMIN_COMPANY_EDIT_INFO_P}`;
export const ADMIN_COMPANY_ADD_P = 'add-company';
export const ADMIN_COMPANY_ADD_PF = `${ADMIN_PF}/${ADMIN_COMPANY_ADD_P}`;
export const LCADMIN_COMPANY_ADD_PF = `${LCADMIN_PF}/${ADMIN_COMPANY_ADD_P}`;
export const ADMIN_COMPANY_ID_P = `company-detail/${ID}`;
export const ADMIN_COMPANY_ID_PF = `${ADMIN_PF}/${ADMIN_COMPANY_ID_P}`;
export const LCADMIN_COMPANY_ID_PF = `${LCADMIN_PF}/${ADMIN_COMPANY_ID_P}`;
export const ADMIN_COMPANY_EDIT_LICENCE_P = `${ADMIN_COMPANY_P}/edit-licence`;
export const ADMIN_COMPANY_EDIT_LICENCE_PF = `${ADMIN_PF}/${ADMIN_COMPANY_EDIT_LICENCE_P}`;

export const ADMIN_USERS_P = 'users';
export const ADMIN_USER_PF = `${ADMIN_PF}/${ADMIN_USERS_P}`;
export const LCADMIN_USER_PF = `${LCADMIN_PF}/${ADMIN_USERS_P}`;
export const ADMIN_USER_ADD_P = `add-user`;
export const ADMIN_USER_ADD_PF = `${ADMIN_PF}/${ADMIN_USER_ADD_P}`;
export const LCADMIN_USER_ADD_PF = `${LCADMIN_PF}/${ADMIN_USER_ADD_P}`;
export const ADMIN_USER_ID_P = `user-detail/${ID}`;
export const ADMIN_USER_ID_PF = `${ADMIN_PF}/${ADMIN_USER_ID_P}`;
export const LCADMIN_USER_ID_PF = `${LCADMIN_PF}/${ADMIN_USER_ID_P}`;

export const ADMIN_ROLES_P = 'roles';
export const ADMIN_ROLE_PF = `${ADMIN_PF}/${ADMIN_ROLES_P}`;
export const LCADMIN_ROLE_PF = `${LCADMIN_PF}/${ADMIN_ROLES_P}`;
export const ADMIN_ROLE_ADD_P = 'add-role';
export const ADMIN_ROLE_ADD_PF = `${ADMIN_PF}/${ADMIN_ROLE_ADD_P}`;
export const LCADMIN_ROLE_ADD_PF = `${LCADMIN_PF}/${ADMIN_ROLE_ADD_P}`;
export const ADMIN_ROLE_ID_P = `role-detail/${ID}`;
export const ADMIN_ROLE_ID_PF = `${ADMIN_PF}/${ADMIN_ROLE_ID_P}`;
export const LCADMIN_ROLE_ID_PF = `${LCADMIN_PF}/${ADMIN_ROLE_ID_P}`;

export const ADMIN_TRADELANES_P = 'trade-lanes';
export const ADMIN_TRADELANE_PF = `${ADMIN_PF}/${ADMIN_TRADELANES_P}`;
export const LCADMIN_TRADELANE_PF = `${LCADMIN_PF}/${ADMIN_TRADELANES_P}`;
export const ADMIN_TRADELANE_ADD_P = `add-trade-lane`;
export const ADMIN_TRADELANE_ADD_PF = `${ADMIN_PF}/${ADMIN_TRADELANE_ADD_P}`;
export const LCADMIN_TRADELANE_ADD_PF = `${LCADMIN_PF}/${ADMIN_TRADELANE_ADD_P}`;
export const ADMIN_TRADELANE_ID_P = `trade-lane-detail/${ID}`;
export const ADMIN_TRADELANE_ID_PF = `${ADMIN_PF}/${ADMIN_TRADELANE_ID_P}`;
export const LCADMIN_TRADELANE_ID_PF = `${LCADMIN_PF}/${ADMIN_TRADELANE_ID_P}`;

export const ADMIN_PARTIES_P = 'parties';
export const ADMIN_PARTIES_PF = `${ADMIN_PF}/${ADMIN_PARTIES_P}`;
export const LCADMIN_PARTIES_PF = `${LCADMIN_PF}/${ADMIN_PARTIES_P}`;

export const ADMIN_CATEGORY_P = 'category';
export const ADMIN_CATEGORY_PF = `${ADMIN_PF}/${ADMIN_CATEGORY_P}`;
export const ADMIN_CATEGORY_ADD_P = 'add-category';
export const ADMIN_CATEGORY_ADD_PF = `${ADMIN_PF}/${ADMIN_CATEGORY_ADD_P}`;
export const ADMIN_CATEGORY_ID_P = `category-detail/${ID}`;
export const ADMIN_CATEGORY_ID_PF = `${ADMIN_PF}/${ADMIN_CATEGORY_ID_P}`;

export const ADMIN_LICENCE_P = 'licence';
export const ADMIN_LICENCE_PF = `${ADMIN_PF}/${ADMIN_LICENCE_P}`;
export const ADMIN_LICENCE_ADD_P = 'add-licence';
export const ADMIN_LICENCE_ADD_PF = `${ADMIN_PF}/${ADMIN_LICENCE_ADD_P}`;
export const ADMIN_LICENCE_ID_P = `licence-detail/${ID}`;
export const ADMIN_LICENCE_ID_PF = `${ADMIN_PF}/${ADMIN_LICENCE_ID_P}`;

